export default {
  wrongAddressFormat: '地址格式錯誤',
  disconnectWallet: '斷開錢包連接',
  memo: '備註',
  stage: '階段',
  tokenomics: '代幣經濟學',
  tokensPurchased: '已購買的代幣',
  youShouldAgree: '您應同意條款和條件',
  requiredField: '必填欄位',
  minValueIs: '最小價值為',
  maxValueIs: '最大價值為',
  cannotCopyToClipboard: '無法複製到剪貼簿',
  copiedToClipboard: '已複製到剪貼簿',
  failed: '操作失敗',
  success: '操作成功',
  aboutUs: '關於我們',
  bonuses: '獎金',
  whitepaper: '白皮書',
  team: '團隊',
  community: '社群',
  checkAddress: '檢查地址',
  currentPrice: '目前價格',
  bonusToBase: '基礎價格獎金',
  raised: '已籌集',
  listingPrice: '上市價格',
  scrollDownTo: '向下滾動以了解更多',
  keyFeaturesOf: 'DOLLUM Wallet的關鍵功能',
  essentialDollumFeatures: '為您的安全和便利而設計的DOLLUM Wallet基本功能。',
  commissionOptimizer: '佣金優化器',
  reduceTransactionCosts: '透過自動選擇最低可用費用來降低交易成本。',
  emergencyStopMode: '緊急停止模式',
  instantlyProtectAssets: '在緊急情況下，透過將資產轉換為USDT來即時保護資產。',
  antiHijackFeature: '防劫持功能',
  lockYourWallet: '透過啟動隱藏的緊急信號，在受到威脅時鎖定您的錢包。',
  cryptoInvestmentPortfolio: '加密貨幣投資組合',
  manageYourCrypto: '透過一鍵使用現成的投資組合來管理您的加密貨幣投資。',
  backupAddress: '備用地址',
  redirectAssetsTo: '在長時間不活動後，將資產重新導向到備用地址。',
  bonusStages: '獎金階段',
  over320Million:
    '全球有超過3.2億人使用加密貨幣，這帶動了對安全加密錢包和金融解決方案的需求。',
  tokenStructure: '代幣結構',
  onlyEmtVill: '預售期間將僅發行210,000,000枚EMT！',
  remainingTokens: '已售出代幣',
  totalRaised: '已售出代幣總數',
  other: '其他',
  is: '是',
  connectWallet: '連接錢包',
  operationInProgress: '交易進行中',
  pleaseWait: '請稍候',
  buying: '購買中',
  for: '為',
  confirmThisTransaction: '在您的錢包中確認此交易',
  changeMetamaskWallet: '更改Metamask Wallet',
  connectedWith: '已連接',
  copyAddress: '複製地址',
  viewOnExplorer: '在瀏覽器上查看',
  checkAddressText:
    '您可以輸入您用來購買我們代幣的錢包地址，以查看其數量和狀態。',
  frozenFor: '凍結時間為 ',
  month: '月',
  months: '個月',
  scheduleOfThe: '資金解凍順序表',
  back: '返回',
  available: '可用',
  buy: '購買',
  enterTheWallet: '請輸入您希望接收DOLLUM代幣的地址。',
  addressMustBe: '仅使用 BSC 网络以安全接收您的代币',
  youAreAt: '您在第',
  of: '步',
  notUseExchangeWallets:
    '仅使用 DeFi 钱包（例如 MetaMask、Trust Wallet、Coinbase Wallet）。请勿使用交易所钱包',
  continue: '繼續',
  youAreOnLast: '您在最後一步',
  youMustTransfer: '您必須轉移資金，金額為',
  address: '地址',
  thisOperationTakes: '此交易最長需要3小時才能完成',
  update: '更新',
  copyTransactionHash: '複製交易哈希',
  copy: '複製',
  depositTheSpecified: '將指定資金存入此錢包',
  balance: '餘額',
  receive: '接收',
  theOperationSuccessful: '交易成功',
  yourFundsWill: '您的資金將轉入您的錢包',
  afterTheCompletion: '所有預售輪結束後，DOL代幣的解鎖流程將啟動',
  theAmountOf: '金額為',
  setOneText1: '2023年加密錢包市場價值達15億美元',
  setOneText2: '40%的市場收入來自加密貨幣交易',
  setOneText3: '未來十年加密貨幣匯款增長50%',
  setTwoText1: '70%的用戶偏愛質押和DeFi整合',
  setTwoText2: '代幣銷售潛在收入達1.75億美元',
  setTwoText3: '10%的總供應量分配給營銷計畫',
  metric: '指標',
  currentMarketState: '當前市場狀態',
  forecastedGrowth: '預測增長',
  userSegments: '用戶細分',
  opportunitiesForDollum: 'DOLLUM Wallet的機會',
  marketValue: '市場價值',
  retailInvestorsFinancial: '散戶投資者、金融機構',
  increasingDemandFor: '對加密錢包的需求不斷增加',
  numberOfCrypto: '加密用戶數量',
  expectedToReach: '預計到2030年將達到5億以上',
  youthEntrepreneursInstitutional: '青年、企業家、機構客戶',
  attractNewUsers: '透過DeFi吸引新用戶',
  mobileWalletShare: '行動錢包市佔率',
  belongsToAndroid: '45%的市場屬於Android',
  mobileSolutionsExpected: '行動解決方案預計每年增長10%',
  smartphoneUsers: '智慧型手機用戶',
  convenienceAndMobile: '便利性和行動存取',
  defiAndStacking: 'DeFi和質押',
  integrationWithDefi: '與DeFi協議的整合',
  exponentialGrowthIn: '對DeFi服務的需求呈指數級增長',
  activeCryptoInvestors: '活躍的加密投資者',
  directAccessTo: '直接存取質押和DEX',
  marketRegions: '市場區域',
  marketLeaders: '市場領導者：北美、亞洲',
  asiaAndLatin: '亞洲和拉丁美洲——最有前途',
  entrepreneursAndLow: '企業家和低收入用戶',
  expansionIntoNew: '擴展到新市場',
  millionCryptoUsers: '全球百萬加密用戶',
  allocationOfFunds: '資金分配',
  seedRound: '種子輪',
  round: '輪',
  Round: '輪',
  tokenPrice: '代幣價格',
  privateRound: '私募輪',
  presaleRound: '預售輪',
  publicSaleRound: '公售輪',
  marketingCommunityBuilding: '營銷、社群建設、空投',
  teamAndFounders: '團隊和創始人',
  ecosystemDevelopmentFund: '生態系統發展基金',
  liquidityFund: '流動性基金',
  stakingRewards: '質押獎勵',
  reserveFund: '儲備基金',
  usersChooseStaking: '70%的用戶選擇在DOLLUM進行質押',
  theMajorityOf:
    '大多數DOLLUM Wallet用戶積極參與質押，以獲得穩定收入並參與DeFi生態系統的增長，同時享受高APY和錢包的安全性。',
  preliminaryEstimateBased: '**這是根據當前市場趨勢所做的初步估計。',
  roadmapText1: '非託管錢包',
  roadmapText1Part2: '核心託管功能',
  roadmapText1Part3: '白皮書',
  roadmapText2: '非託管錢包',
  roadmapText2Part2: '核心託管功能 ',
  roadmapText2Part3: '白皮書 ',
  roadmapText3: '防劫持',
  roadmapText3Part2: '錢包啟動 ',
  roadmapText3Part3: '備用地址功能',
  roadmapText3Part4: '緊急轉移 ',
  roadmapText3Part5: '投資組合管理工具',
  roadmapText4: '代幣經濟學和代幣銷售',
  roadmapText4Part2: '佣金優化器',
  roadmapText4Part3: '交易內訊息功能',
  roadmapText5: '錢包內NFT功能',
  roadmapText5Part2: '用法幣購買加密貨幣',
  roadmapText5Part3: '使用非託管錢包功能進行兌換',
  roadmapText6: '公開測試版',
  roadmapText6Part2:
    '與全球銀行機構建立策略聯盟，將DOL代幣整合為美元標準資產。',
  roadmapText6Part3: '銀行卡',
  roadmapText6Part4: '在加密貨幣交易所上市',
  roadmapText6Part5: 'Dollum加密貨幣交易所測試版',
  roadmapText7: '錢包啟動',
  roadmapText7Part2: '將DOL代幣作為政府主導計畫的數位工具。',
  roadmapText7Part3: 'Dollum區塊鏈',
  roadmapText7Part4: 'NFT市場測試版',
  roadmapText8: '加密貨幣交易所上線',
  roadmapText8Part2: 'NFT市場上線',
  tokenRoadmap: '代幣發展路線圖',
  roadmap: '路線圖',
  competitorComparison: '競爭對手比較',
  featureAttribute: '功能/屬性',
  typeOfWallet: '錢包類型',
  custodialNonCustodial: '託管和非託管',
  nonCustodial: '非託管',
  cryptocurrenciesSupported: '支援的加密貨幣',
  bitcoinEthereumTron: '比特幣、以太坊、波場、Polygon等',
  thousandCoins: '1,000多種幣',
  ethereumTokens: '以太坊、ERC-20代幣',
  assets130: '130多種資產',
  assets500: '500多種資產',
  supportedPlatforms: '支援的平台',
  defiIntegration: 'DeFi整合',
  yes: '是',
  stakingSupport: '質押支援',
  no: '否',
  tokenSwapping: '代幣兌換',
  yesNativeExternal: '是（原生和外部）',
  securityFeatures: '安全功能',
  biometricPassword: '生物識別、密碼',
  passwordPrivateKey: '密碼、私鑰',
  biometric2Fa: '生物識別、2FA',
  kycCompliance: 'KYC/AML合規性',
  yesForCustodial: '是（針對託管）',
  backupRecovery: '備份與恢復',
  yesSeedPhrases: '是（助記詞、2FA）',
  yesSeedPhrase: '是（助記詞）',
  supportedBlockchains: '支援的區塊鏈',
  multiBlockChainCustom: '多鏈（可自訂）',
  multiBlockchain: '多鏈',
  userInterface: '用戶介面',
  intuitiveCustomizable: '直觀、可自訂（深色/淺色主題）',
  simpleCleanInterface: '簡潔的介面',
  simpleDeveloperFocused: '簡單、以開發人員為中心',
  cleanAndUser: '簡潔且易於使用',
  visualAppealing: '視覺上吸引人、可自訂',
  cleanSimple: '簡潔、簡單',
  crossChainSwapping: '跨鏈兌換',
  fees: '費用',
  adjustableOptimizedUsing: '可調整，使用佣金優化器進行優化',
  adjustable: '可調整',
  fixedForCustodial: '託管固定；非託管可調整',
  backupAddressFeature: '備用地址功能',
  yesNonCustodial: '是（非託管）',
  pushNotifications: '推播通知',
  hardwareWalletSupport: '硬體錢包支援',
  yesViaTrezor: '是（透過Trezor）',
  yesLedgerTrezor: '是（Ledger/Trezor）',
  yesTrezor: '是（Trezor）',
  yesLedger: '是（Ledger）',
  nftSupport: 'NFT支援',
  feeOptimization: '費用優化',
  yesCommissionOptimizer: '是（佣金優化器）',
  twoFactorAuth: '雙重身份驗證（2FA）',
  fiatConversion: '法幣轉換',
  yesCustodialOnly: '是（僅限託管）',
  mobileSpecificFeatures: '行動裝置專屬功能',
  storiesEmergencyStop: '限時動態、緊急停止、防劫持',
  none: '無',
  adminPanel: '管理面板',
  yesCustodialService: '是（針對託管服務）',
  nativeDexAddress: '原生DEX存取',
  decentralizedAppBrowser: '去中心化應用程式瀏覽器',
  biometricLogin: '生物識別登入',
  reputationSystem: '信譽系統',
  yesInternalWallet: '是（內部錢包評級）',
  additionalSecurityTools: '額外安全工具',
  emergencyStopAnti: '緊急停止、防劫持',
  languagesSupport: '支援的語言',
  multiLanguageSupport: '多語言支援',
  english: '英文',
  customerSupport: '客戶支援',
  yesBuildIt: '是（內建支援選項）',
  yesHelpCenter: '是（幫助中心）',
  yes24Support: '是（24/7全天候支援）',
  yesInApp: '是（應用程式內支援）',
  frequentlyAskedQuestions: '常見問題',
  howFindFrequently: '您可以在這裡找到所有關於我們產品的常見問題',
  faqTitle1: '如何在DOLLUM Wallet中創建錢包？',
  faqTitle2: 'DOLLUM Wallet收取哪些費用？',
  faqTitle3: '錢包是否支援DeFi整合？',
  faqTitle4: '如何使用「緊急停止」功能？',
  faqTitle5: 'DOLLUM Wallet可以用來儲存NFT嗎？',
  faqTitle6: '如果我的設備丟失了，我該如何恢復錢包存取權限？',
  faqText1:
    '要創建錢包，只需下載應用程式，完成註冊，選擇錢包類型（託管/非託管），並安全地儲存您的助記詞即可。',
  faqText2:
    'DOLLUM Wallet透過選擇最低可用費率來自動優化交易費用，從而將用戶在操作期間的成本降至最低。',
  faqText3:
    '是的，DOLLUM Wallet完全支援DeFi協議，允許用戶透過整合的DEX參與質押、農耕和代幣兌換。',
  faqText4:
    '如果安全性受到威脅，緊急停止功能會立即將資產轉換為穩定幣或鎖定錢包。可以透過錢包的設定來啟用。',
  faqText5:
    '是的，DOLLUM Wallet支援NFT的儲存、瀏覽和交易，允許用戶直接在錢包內安全地管理他們的數位收藏。',
  faqText6:
    '您可以使用在錢包創建期間提供的助記詞來恢復對錢包的存取權限。請務必將助記詞儲存在安全的位置。',
  footerReservedText:
    '本網站由SecureLabs LTd運營，該公司根據塞舌爾法律註冊成立，註冊地址：Suite 1, Second Floor, Sound & Vision House, Rue Pierre De Possession, Victoria, Mahe, Seychelles。版權所有',
  termsOfUse: '使用條款',
  privacyPolicy: '隱私權政策',
  cookiePreferences: 'Cookie偏好設定',
  agreeToTransaction: '我同意此交易，以及在 ',
  and: '和',
  termsAndConditions: '「條款和條件」中描述的條款',
  alsoYouCan: '您也可以在 ',
  usingTheTransaction:
    '使用交易哈希驗證您的分配確認。您可以隨時在此網站上透過提供接收地址，查看您的DOL代幣的詳細解鎖時間表。',
  followUsOn: '在社群媒體上關注我們',
  lockedFor: '鎖定',
  selectNetwork: '選擇網絡',
  dolTokenWill: 'DOL代幣將在幣安智慧鏈網絡上發布',
  copyTxHash: '複製交易哈希',
  theOperationExpired: '操作已過期',
  waitingTimeHas: '等待時間已過期，請重試',
  ifTheProblem: '如果問題再次發生，請 ',
  sendUsEmail: '給我們發送電子郵件',
  contactSupport: '聯繫支援',
  tryAgain: '再試一次',
  theOperationFailed: '操作失敗',
  error: '錯誤',
  tokenUnlockingSchedule: '代幣解鎖時間表:',
  promoCodeUsed: '促銷代碼已成功使用',
  congratulations: '恭喜',
  youCanActivate: '您可以啟用促銷代碼，獲得 ',
  activateYourPromocode: '激活您的促銷代碼',
  getting: '獲得',
  totalRaisedInUsd: '總籌集金額',
  nextStage: '下一階段',
  pay: '付款',
  info: '資訊',
  dollumApp: 'Dollum App',
  trustApp: 'Trust App',
  metamask: 'Metamask',
  coinbaseApp: 'Coinbase App',
  exodusApp: 'Exodus App',
  cryptoComDefi: 'Crypto.com DeFi',
  bonusRowsState1: '2023年達15億美元',
  bonusRowsGrowth1: '2023年達15億美元',
  bonusRowsState2: '3.2億多加密用戶',
  multiformatSupport: '比特幣、以太坊、ERC-20',
  iosAndroidDesktopLightVersion: 'iOS、Android、桌面版（輕量版）',
  iosAndroid: 'iOS、Android',
  iosAndroidChrome: 'iOS、Android、Chrome',
  iosAndroidBrowser: 'iOS、Android、瀏覽器',
  iosAndroidDesktop: 'iOS、Android、桌面版',
  biometricPin2Fa:
    '生物識別、PIN、2FA、SSL綁定、AES-256加密、「緊急停止」、「防劫持」',
  ethereum: '以太坊',

  poweredBy: '由...提供支持',
  live: '直播',
  auditAndKycVerified: '审计和KYC验证',
  teamKycVerification: '团队KYC验证',
  smartContractAudit: '智能合约审计',
  securityComesFirst: '安全第一。',
  ourSmartContractHasBeenFullyAudited: '我们的智能合约已被全面审计',
  bySolidProof: '由SolidProof，',
  oneOfTheLeadingBlockchainAuditFirms: '领先的区块链审计公司之一。',
  additionally: '此外，',
  dollumTeamCompletedKYC: 'Dollum团队已成功完成KYC验证',
  ensuringTransparencyAndAccountability: '，确保社区的透明度和责任。',
  servicesAndCertificates: '服务和证书',
  kyc: 'KYC',
  securityScore: '安全评分',
  poor: '差',
  excellent: '优秀',
  writesMediaAboutUs: '媒体关于我们的报道',

  stageTwoAlmostSold: '第二阶段即将售罄 — 下一价格：$0.20',
  buyBeforeThePriceIncreases: '立即以 $0.15 购买，价格即将上涨！',

  useOnlyDefiWallet:
    '仅使用 DeFi 钱包，例如 MetaMask、Trust Wallet 或 Coinbase Wallet。',
  makeSureYourWalletIsConnectedToTheBsc:
    '请确保您的钱包已连接到 BSC（币安智能链）网络。',
  copyYourBscWalletAddress:
    '复制您的 BSC 钱包地址（以 0x 开头）并粘贴到输入框中。',
  doNotUseExchangeWallets:
    '请勿使用交易所钱包（例如 Binance、KuCoin 或 OKX）。',

  needHelp: '需要帮助吗？',

  stage3IsSellingFast: '最终预售阶段 — 上线前的最后机会',
  nextStagePriceIncreases: '在计划的 $1.00 初始上市价格之前立即获取您的代币',
  finalPresaleStage: '最终预售阶段',

  weAreLive: '我们已上线！',
  weWillLiveSoon: '我们即将上线',
  startManagingYourCryptoSecurely: '开始安全管理您的加密资产',

  launchpadIntroduction: 'Launchpad 介绍',
  continuedPlatformDevelopment: '平台持续发展与生态系统扩展',
  expansionIntoIntegratedFinancialServices:
    '拓展至综合金融服务，包括支付和借贷功能',
  ecosystemScaling: '生态系统规模化与功能扩展',
  platformOptimizationAndInfrastructure: '平台优化与基础设施强化',
  platformForBroaderMarketIntegration: '为更广泛的市场整合做准备',
  structuredDigitalFinanceEcosystem: '结构化数字金融生态系统',
  dollumCombinesSecureWallet:
    'Dollum 在统一平台中整合安全钱包基础设施、质押和金融工具 —— 并扩展至支付和借贷功能。',
  finalStageLimitedAllocationRemaining: '最终阶段——剩余配额有限',

  nowAvailable: '现已可用',
  digitalAssetManagement: '具有集成支付功能的数字资产管理',
};
